require('./brokerMainStocksResultsListBox.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @helpers
const { formatText } = require('core/i18n').i18n;
// @commons
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @components
const { BrokerMainStocksResultsListContent } = require('components/broker/brokerMainStocksResultsListContent/brokerMainStocksResultsListContent');
// @constants
const BROKER_MARKET_INDEXES_EXCLUDED_INDEX = require('constants/index');
const {BROKER_MAIN_STOCKS_TAB_RISERS} = require('constants/index');

class BrokerMainStocksResultsListBox extends React.Component {
    onlyOneTypeStock(list,order) {
        return (order === 'risers') ?
            list.filter((entry) => entry.get('netChangePrice') > 0)
            :
            list.filter((entry) => entry.get('netChangePrice') < 0);
    }

    contructor() {
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immTodaysMainStocks, selectedMarket, titlePrefix, hasControls, hasFilter, immBrokerExchangeIndexes } = this.props;
        const selectedIndex = immBrokerExchangeIndexes.get('indexes').find(index => index.get('spcSymbol') === selectedMarket);
        const indexTitle = !!selectedIndex ? selectedIndex.get('instrument') : '';
        const title = titlePrefix ? `${formatText(titlePrefix)} ${selectedMarket}` : indexTitle;
        let content;

        if (hasControls) {
            const RISERS = "Risers";
            const FALLERS = "Fallers";
            const BYVOLUME = "ByVolume";
            const immStocksByPercentageRisers = this.onlyOneTypeStock(immTodaysMainStocks.getIn(['stocksByMarket', selectedMarket, 'byPercentage', 'risers']),'risers');
            const immStocksByPercentageFallers = this.onlyOneTypeStock(immTodaysMainStocks.getIn(['stocksByMarket', selectedMarket, 'byPercentage', 'fallers']),'fallers');
            const immStocksByVolumeRisers = immTodaysMainStocks.getIn(['stocksByMarket', selectedMarket, 'byVolume', 'risers']);
            const byPercentageRisers = <BrokerMainStocksResultsListContent title={formatText('broker-mainStocksPercentageRisersTitle')} immStocks={immStocksByPercentageRisers} selectedType={RISERS}/>;
            const byPercentageFallers = <BrokerMainStocksResultsListContent title={formatText('broker-mainStocksPercentageFallersTitle')} immStocks={immStocksByPercentageFallers} selectedType={FALLERS}/>;
            const byVolumeRisers = <BrokerMainStocksResultsListContent title={formatText('broker-mainStocksVolumeRisersTitle')} immStocks={immStocksByVolumeRisers} selectedType={BYVOLUME}/>;
            const byPercentageRisersLabel = formatText('broker-mainStocksPercentageRisersTabLabel');
            const byPercentageFallersLabel = formatText('broker-mainStocksPercentageFallersTabLabel');
            const byVolumeRisersLabel = formatText('broker-mainStocksVolumeRisersTabLabel');

            content = (
                <TabbedContentBox
                    id="brokerMainStocksResultsListTabs"
                    tabComponents={[byPercentageRisers, byPercentageFallers, byVolumeRisers]}
                    tabLabels={[byPercentageRisersLabel, byPercentageFallersLabel, byVolumeRisersLabel]}
                    title={title}
                    customClassName="broker-main-stocks-results-list"
                    defaultTabIndex={this.props.selectedTab}
                />
            );
        } else if (hasFilter) {
            const immStocks = immTodaysMainStocks.get('stocks').delete(BROKER_MARKET_INDEXES_EXCLUDED_INDEX);
            content = (
                <OKSectionBox className="broker-main-stocks-results-list-box__filtered">
                    <h3 className="broker-main-stocks-results-list-box__filtered-title">
                        {title}
                    </h3>
                    <BrokerMainStocksResultsListContent
                        immStocks={immStocks}
                        hasFilters={true}
                    />
                </OKSectionBox>
            );
        }

        return content;
    }
}

BrokerMainStocksResultsListBox.propTypes = {
    immTodaysMainStocks: PropTypes.object.isRequired,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    selectedMarket: PropTypes.string,
    titlePrefix: PropTypes.string,
    hasControls: PropTypes.bool,
    hasFilter: PropTypes.bool,
    selectedTab: PropTypes.number,
};

BrokerMainStocksResultsListBox.defaultProps = {
    hasControls: true,
    hasFilter: false,
    selectedTab: BROKER_MAIN_STOCKS_TAB_RISERS,
}

module.exports = BrokerMainStocksResultsListBox;
